import React from "react";
import { PiXLogo } from "react-icons/pi";
import {
  FiSettings,
  FiMonitor,
  FiHome,
  FiChevronRight,
  FiMenu,
  FiActivity,
  FiAlertTriangle,
  FiBarChart2,
  FiClock,
  FiFileText,
  FiShield,
  FiUpload,
  FiPackage,
  FiUsers,
} from "react-icons/fi";
import Button from "react-bootstrap/Button";
import { useLocation } from "react-router-dom";

const ADMIN_PAGES = {
  health: { icon: <FiActivity />, title: "Monitor Health" },
  alerts: { icon: <FiAlertTriangle />, title: "Alerts" },
  bandwidth: { icon: <FiBarChart2 />, title: "Bandwidth & Cost" },
  stale: { icon: <FiClock />, title: "Stale Monitors" },
  logs: { icon: <FiFileText />, title: "Logs" },
  observability: { icon: <FiActivity />, title: "Observability" },
  runtime: { icon: <FiShield />, title: "Runtime Validation" },
  proxies: { icon: <FiUpload />, title: "Upload Proxies" },
  products: { icon: <FiPackage />, title: "Products" },
  clients: { icon: <FiUsers />, title: "Clients" },
};

const Header = ({ toggleSidebar }) => {
  const location = useLocation();

  const linkHandler = () => {
    window.open("https://x.com/thescrapingbook", "_blank");
  };

  const getPageInfo = () => {
    const [, section, page] = location.pathname.split("/");
    if (section === "admin") {
      const admin = ADMIN_PAGES[page] || ADMIN_PAGES.health;
      return {
        icon: React.cloneElement(admin.icon, { className: "fs-20 text-gray" }),
        title: admin.title,
        breadcrumb: ["Admin", admin.title],
      };
    }
    switch (location.pathname) {
      case "/":
        return {
          icon: <FiSettings className="fs-20 text-gray" />,
          title: "General Settings",
          breadcrumb: ["Home", "General Settings"],
        };
      case "/monitors":
        return {
          icon: <FiMonitor className="fs-20 text-gray" />,
          title: "Monitor Settings",
          breadcrumb: ["Monitors", "Sneaker & Alternative"],
        };
      default:
        return {
          icon: <FiHome className="fs-20 text-gray" />,
          title: "Dashboard",
          breadcrumb: ["Home"],
        };
    }
  };

  const pageInfo = getPageInfo();

  return (
    <div className="general-header w-84 d-flex justify-content-between align-items-center px-3">
      <div className="d-flex align-items-center gap-2">
        {toggleSidebar && (
          <button className="hamburger-btn" onClick={toggleSidebar}>
            <FiMenu />
          </button>
        )}
        {pageInfo.icon}
        <div className="d-flex align-items-center gap-2">
          {pageInfo.breadcrumb.map((item, index) => (
            <React.Fragment key={index}>
              {index > 0 && <FiChevronRight className="text-white-45 fs-12" />}
              <span
                className={
                  index === pageInfo.breadcrumb.length - 1
                    ? "text-main fs-14 fw-500"
                    : "text-white-45 fs-14"
                }
              >
                {item}
              </span>
            </React.Fragment>
          ))}
        </div>
      </div>
      <Button
        onClick={linkHandler}
        variant=""
        className="text-white px-3 py-2 border-0 fs-13 fw-500 rounded-pill bg-white-15 d-none d-md-inline-block"
      >
        Follow Us on <PiXLogo className="fs-20" />
      </Button>
    </div>
  );
};

export default Header;
